import { TextSelection } from 'prosemirror-state'

import type { Command } from 'common/Prose/Commands'
import { getPreviousTextPosition } from 'common/Prose/utils'
import { NodeType } from 'prosemirror-model'
import { schema as nerudaSchema } from 'prose-core'

const ignoredNodeTypes: NodeType[] = [nerudaSchema.nodes.summary]

export const deleteEmptyNode: Command = ({ selection: { $from, empty }, tr }, dispatch) => {
  if (!empty) return false
  if ($from.pos !== $from.start()) return false
  if ($from.node().childCount !== 0) return false
  if (ignoredNodeTypes.includes($from.node(-1).type)) return false

  tr.delete($from.before(), $from.after())
  tr.setSelection(new TextSelection(getPreviousTextPosition(tr.doc.resolve($from.before()))))

  dispatch?.(tr)

  return true
}
